var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "指定物流",
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发货逻辑仓名称" } },
                [
                  _c("BjInput", {
                    staticClass: "input-default-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.stockWarehouseName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "stockWarehouseName", $$v)
                      },
                      expression: "form.stockWarehouseName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择物流", prop: "defaultLogisticsFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onRadio },
                      model: {
                        value: _vm.form.defaultLogisticsFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "defaultLogisticsFlag", $$v)
                        },
                        expression: "form.defaultLogisticsFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("指定物流商"),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("默认物流"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "指定物流商",
                    prop: "logisticCompanyCode",
                    rules: _vm.checkRules ? _vm.rules.logisticCompanyCode : {},
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.list.length === 0 &&
                            !_vm.form.defaultLogisticsFlag,
                          expression:
                            "list.length === 0 && !form.defaultLogisticsFlag",
                        },
                      ],
                    },
                    [_vm._v("暂无可发该包裹的物流")]
                  ),
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.form.defaultLogisticsFlag &&
                            _vm.list.length > 0,
                          expression:
                            "!form.defaultLogisticsFlag && list.length > 0",
                        },
                      ],
                      staticClass: "input-default-width",
                      attrs: { placeholder: _vm.$t("chooseText") },
                      on: { change: _vm.changeCompanyId },
                      model: {
                        value: _vm.form.logisticCompanyCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "logisticCompanyCode", $$v)
                        },
                        expression: "form.logisticCompanyCode",
                      },
                    },
                    _vm._l(_vm.list, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                  _c("BjInput", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.form.defaultLogisticsFlag &&
                          Object.keys(_vm.defaultLogistics).length > 0,
                        expression:
                          "form.defaultLogisticsFlag && Object.keys(defaultLogistics).length > 0",
                      },
                    ],
                    staticClass: "input-default-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.logisticCompanyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "logisticCompanyName", $$v)
                      },
                      expression: "form.logisticCompanyName",
                    },
                  }),
                  Object.keys(_vm.defaultLogistics).length === 0 &&
                  _vm.form.defaultLogisticsFlag
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("table.emptyText")))])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.list.length > 0 || _vm.form.defaultLogisticsFlag,
                      expression:
                        "list.length > 0 || form.defaultLogisticsFlag",
                    },
                  ],
                  attrs: {
                    label: "指定物流业务",
                    prop: "logisticBusinessCode",
                    rules: _vm.checkRules
                      ? _vm.rules.logisticBusinessCode
                      : null,
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.form.defaultLogisticsFlag &&
                            _vm.list.length > 0,
                          expression:
                            "!form.defaultLogisticsFlag && list.length > 0",
                        },
                      ],
                      staticClass: "input-default-width",
                      attrs: {
                        disabled: !_vm.form.logisticCompanyCode,
                        placeholder: _vm.$t("chooseText"),
                      },
                      on: { change: _vm.changeBusinessCode },
                      model: {
                        value: _vm.form.logisticBusinessCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "logisticBusinessCode", $$v)
                        },
                        expression: "form.logisticBusinessCode",
                      },
                    },
                    _vm._l(_vm.businessList, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                  _c("BjInput", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.form.defaultLogisticsFlag &&
                          Object.keys(_vm.defaultLogistics).length > 0,
                        expression:
                          "form.defaultLogisticsFlag && Object.keys(defaultLogistics).length > 0",
                      },
                    ],
                    staticClass: "input-default-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.logisticBusinessName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "logisticBusinessName", $$v)
                      },
                      expression: "form.logisticBusinessName",
                    },
                  }),
                  Object.keys(_vm.defaultLogistics).length === 0 &&
                  _vm.form.defaultLogisticsFlag
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("table.emptyText")))])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _vm.showLastBtn
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onLast } },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }